import { useFormik } from 'formik'
import React from 'react'
import ModalComponent from '..'
import { Button } from '../../button'
import { TextInput } from '../../inputs/textInput'

import { AddComboItemSchema } from '../../../validation/validate'

import { NumericFormat } from 'react-number-format'
import { getCurrencySymbol, parseCurrencyToNumber } from '../../../helpers'
import {
  ComboItem,
  ComboItemType,
} from '../../../redux-toolkits/products/products.type'
import ComboBox from '../../inputs/combobox'

export const AddComboItemModal: React.FC<{
  open: boolean
  setOpen: (cal: boolean) => void
  onCloseCallback?: () => void
  onSuccessCallback?: (val: ComboItem) => void
  mode: 'edit' | 'create'
  comboItem?: ComboItem
}> = ({
  open,
  setOpen,
  onCloseCallback = () => {},
  onSuccessCallback = (val) => {},
  mode,
  comboItem,
}) => {
  const {
    values,
    errors,
    handleSubmit,
    handleChange,
    handleBlur,
    touched,
    isValid,
    resetForm,
    setFieldValue,
    initialValues,
  } = useFormik({
    initialValues: comboItem
      ? {
          name: comboItem.name,
          price: comboItem.price,
          minimumQuantity: comboItem.minimumQuantity,
          maximumQuantity: comboItem.maximumQuantity,
          required: comboItem.required,
          type: comboItem.type,
        }
      : {
          name: '',
          price: '0',
          minimumQuantity: '0',
          maximumQuantity: '1',
          required: false,
          type: 'quantity' as ComboItemType,
        },
    enableReinitialize: true,
    validationSchema: AddComboItemSchema,
    onSubmit: (values, { resetForm }) => {
      const itemToAdd: ComboItem = {
        name: values.name,
        price: parseCurrencyToNumber(values.price),
        isProduct: false,
        minimumQuantity: Number(values.minimumQuantity),
        maximumQuantity: Number(values.maximumQuantity),
        required: values.required,
        type: values.type,
      }

      onSuccessCallback(itemToAdd)
      resetForm()
    },
  })

  return (
    <ModalComponent
      open={open}
      setOpen={setOpen}
      onCloseCallback={() => {
        resetForm()
        onCloseCallback()
      }}
      title={mode === 'create' ? 'Add Combo Item' : 'Edit Combo Item'}
      childrenClassName="md:!max-w-[420px]"
    >
      <div className="flex flex-col gap-4">
        <div className="grid grid-cols-2 gap-4">
          <TextInput
            type="text"
            name="name"
            placeholder="Name"
            value={values.name}
            onBlur={handleBlur}
            onChange={handleChange}
            errors={errors.name && touched.name ? errors.name : ''}
            hasIcon={false}
            title="Name"
            containerClassName="col-span-full"
          />

          <NumericFormat
            suffix={undefined}
            prefix={getCurrencySymbol('NGN')}
            customInput={TextInput}
            type="text"
            name="price"
            placeholder="Price"
            value={values.price}
            onBlur={handleBlur}
            onChange={handleChange}
            errors={errors.price && touched.price ? errors.price : ''}
            hasIcon={false}
            title="Price"
            containerClassName="col-span-full"
            decimalScale={2}
            thousandSeparator
          />

          <ComboBox
            type="text"
            name="type"
            placeholder="Select type"
            value={values.type}
            onChange={() => {}}
            onBlur={handleBlur}
            hasIcon={false}
            errors={errors.type && touched.type ? errors.type : ''}
            menuItems={(['portion', 'quantity'] as ComboItemType[]).map(
              (itm) => {
                return {
                  name: itm,
                  value: itm,
                }
              },
            )}
            onSelectOption={(selected) => {
              setFieldValue('type', selected)
            }}
            title="Type"
            onSearch={() => {}}
            loading={false}
            immediate
            position="bottom start"
            menuClassName="!max-h-[250px] shadow-md !z-[999]"
            containerClassName="col-span-full"
            className="col-span-full"
            isDropdown
          />

          <TextInput
            type="text"
            name="minimumQuantity"
            placeholder="Minimum quantity"
            value={String(values.minimumQuantity)}
            onBlur={handleBlur}
            onChange={handleChange}
            errors={
              errors.minimumQuantity && touched.minimumQuantity
                ? errors.minimumQuantity
                : ''
            }
            hasIcon={false}
            title="Minimum quantity"
          />

          <TextInput
            type="text"
            name="maximumQuantity"
            placeholder="Maximum quantity"
            value={String(values.maximumQuantity)}
            onBlur={handleBlur}
            onChange={handleChange}
            errors={
              errors.maximumQuantity && touched.maximumQuantity
                ? errors.maximumQuantity
                : ''
            }
            hasIcon={false}
            title="Maximum quantity"
          />

          {/* <Checkbox
            text="This is a required item"
            checkStatus={values.required}
            handleChange={(status) => {
              setFieldValue('required', status)
            }}
            className="col-span-full"
          /> */}
        </div>

        <Button
          label="Proceed"
          type="submit"
          className="mt-10"
          disabled={!isValid}
          loading={false}
          primary
          onClick={() => {
            handleSubmit()
          }}
        />
      </div>
    </ModalComponent>
  )
}
